const languageMixin = {
  methods: {
    getLanguage() {
      const meLanguage = this.$store.state.me.language
      const lowercaseLanguage = meLanguage ? meLanguage.toLowerCase() : ''
      return lowercaseLanguage.slice(0, 2)
    },
  },
}

export default languageMixin
